/**
 * Versão simplificada das variantes sem dependência do cva
 * Para resolver o problema "cva is not defined"
 */

export type BadgeVariant =
  | "default"
  | "secondary"
  | "destructive"
  | "outline"
  | "success"
  | "warning";
export type ButtonVariant = "default" | "destructive" | "outline" | "secondary" | "ghost" | "link";
export type ButtonSize = "default" | "sm" | "lg" | "icon";

// Versão simplificada das variantes do botão
export const buttonVariants = {
  base: "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-xs sm:text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-3 sm:[&_svg]:size-4 [&_svg]:shrink-0",

  variants: {
    variant: {
      default: "bg-primary text-primary-foreground hover:bg-primary/90",
      destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
      outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
      secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
      ghost: "hover:bg-accent hover:text-accent-foreground",
      link: "text-primary underline-offset-4 hover:underline",
    },
    size: {
      default: "h-8 sm:h-10 px-3 sm:px-4 py-1.5 sm:py-2",
      sm: "h-7 sm:h-9 rounded-md px-2.5 sm:px-3",
      lg: "h-9 sm:h-11 rounded-md px-6 sm:px-8",
      icon: "h-8 w-8 sm:h-10 sm:w-10",
    },
  },

  // Função para gerar classes Tailwind
  generate: (options: { variant?: ButtonVariant; size?: ButtonSize; className?: string }) => {
    const variantClass = options.variant
      ? buttonVariants.variants.variant[options.variant]
      : buttonVariants.variants.variant.default;
    const sizeClass = options.size
      ? buttonVariants.variants.size[options.size]
      : buttonVariants.variants.size.default;
    const baseClass = buttonVariants.base;

    return `${baseClass} ${variantClass} ${sizeClass} ${options.className || ""}`.trim();
  },
};

// Versão simplificada das variantes do badge
export const badgeVariants = {
  base: "inline-flex items-center rounded-full border px-2 sm:px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",

  variants: {
    variant: {
      default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
      secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
      destructive:
        "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
      outline: "text-foreground",
      success: "border-transparent bg-green-100 text-green-800 hover:bg-green-200",
      warning:
        "border-transparent bg-amber-100 text-amber-800 hover:bg-amber-200 dark:bg-amber-950/60 dark:text-amber-200 dark:hover:bg-amber-900/60",
    },
  },

  generate: (options: { variant?: BadgeVariant; className?: string }) => {
    const variantClass = options.variant
      ? badgeVariants.variants.variant[options.variant]
      : badgeVariants.variants.variant.default;
    const baseClass = badgeVariants.base;

    return `${baseClass} ${variantClass} ${options.className || ""}`.trim();
  },
};

export const navigationMenuTriggerStyle =
  "group inline-flex h-10 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50";
